<template>
  <div class="profile-exam" style="background-color: #f0f0f0;">
    <Header />
    <div
      ref="table"
      v-loading="listLoading"
      style="margin: 0 auto;margin-top: 20px;min-height: calc(100vh - 504px);width: 1120px;background-color: #fff;"
      class="profile-exam-table"
    >
      <el-table
        :class-name="['table-gray', 'small']"
        :data="list"
        :show-header="false"
        :total="total"
        :max-height="tableHeight"
        show-overflow-tooltip
      >
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <normal-item :data="scope.row" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { Table, TableColumn, Loading } from "element-ui";
// import HeaderM from "../humanSociety/components/header.vue";
// import FooterM from "../humanSociety/components/footer.vue";
import { mapState } from "vuex";
Vue.use(Loading);

import NormalItem from "./normalItem";
export default {
  components: {
    "normal-item": NormalItem,
    "el-table": Table,
    "el-table-column": TableColumn,
    // HeaderM,
    // FooterM,
  },
  //   computed: mapState(["globalConfig"]),
  data() {
    return {
      tableHeight: null,
      total: "",
      list: [],
      listLoading: false,
      dialogTableVisible: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    if(this.userInfo.grade!==3){
      this.$refs.table.innerHTML = '<div class="no-auth" >暂无权限</div>'
      this.$common.noAuthTips(3,this.$router);
      return false
    }
    this.initData();
    this.initTableHeight();
  },
  methods: {
    async initData() {
      this.listLoading = true;
      try {
        const res = await this.$http.get("/api/exam/getExamAffairList", {});
        this.listLoading = false;
        console.log(res,'res')
        if (res) {
          this.list = res;
          this.total = res.length;
        }
      } catch (error) {
        this.listLoading = false;
        this.$message.error(error.message);
      }
      
    },
    initTableHeight() {
      const dom = document.documentElement || document.body;
      const lh = 140;
      this.tableHeight = dom.clientHeight - lh;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-exam {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.profile-header-title {
  padding: 0 !important;
}
.no-auth{
  text-align: center;
}
</style>
